<template>
  <div>
    <div class="mb-4">
      <h6 class="text-base inline-block">Line Items</h6>
      &nbsp;
      <a role="button" class="inline-block" @click="addLine"> Add Line </a>
    </div>
    <div class="grid gap-y-1">
      <InvoiceLineHeaderItem />

      <InvoiceLineItem
        v-for="(lineItem, idx) in invoiceLines"
        :key="`line_item_${idx}`"
        :num="idx"
        :description.sync="lineItem.description"
        :quantity.sync="lineItem.quantity"
        :price-per-unit.sync="lineItem.pricePerUnit"
        :net-amount.sync="lineItem.netAmount"
        :vat-rate.sync="lineItem.vatRate"
        :vat-amount.sync="lineItem.vatAmount"
        :total.sync="lineItem.total"
        :disabled="disabled"
        @invoice-line-item:remove="removeLine(idx)"
      />

      <InvoiceLineFooterItem :line-items="invoiceLines" />
    </div>
  </div>
</template>

<script>
import InvoiceLineItemVue from './InvoiceLineItem.vue';
import InvoiceLineHeaderItemVue from './InvoiceLineHeaderItem.vue';
import InvoiceLineFooterItemVue from './InvoiceLineFooterItem.vue';

const DEFAULT_LINE_ITEM = {
  description: '',
  quantity: 1,
  pricePerUnit: 0,
  netAmount: 0,
  vatRate: 0.24,
  vatAmount: 0,
  total: 0,
};
export default {
  components: {
    InvoiceLineHeaderItem: InvoiceLineHeaderItemVue,
    InvoiceLineItem: InvoiceLineItemVue,
    InvoiceLineFooterItem: InvoiceLineFooterItemVue,
  },

  props: {
    invoiceLines: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  data() {
    return {
      data: [
        //
      ],
    };
  },

  methods: {
    addLine() {
      this.$emit('update:invoice-lines', [...this.invoiceLines, { ...DEFAULT_LINE_ITEM }]);
    },
    removeLine(removedIndex) {
      this.$emit('update:invoice-lines', [
        ...this.invoiceLines.filter((line, index) => index !== removedIndex),
      ]);
    },
  },
};
</script>
